import React from "react";
import { Helmet } from "react-helmet";
import { graphql } from "gatsby";
import Navbar from "../components/Navbar";
import { Location } from "@reach/router";

type Album = {
  Title: string;
  Price: number;
  url: string;
  music_tracks: MusicTrack[];
};

type MusicTrack = {
  id: string;
  Image: string;
  Price: number;
  Title: string;
  File_GUID: string;
};

const AlbumPage: React.FC<{ data: { strapiAlbum: Album }; location: any }> = ({
  data,
  location,
}) => {
  const { strapiAlbum } = data;
  console.log(location);
  function createMusicsInAlbum() {
    return strapiAlbum.music_tracks.map(music => (
      <div className="mt-4" key={music.id}>
        <div className="flex">
          <div>{music.Title}</div>
          <button
            className="snipcart-add-item border mx-4 px-4 bg-blue-500 text-white hover:bg-blue-400"
            data-item-id={"music-" + music.id}
            data-item-price={music.Price}
            data-item-image={music.Image}
            data-item-name={music.Title}
            data-item-url={location.pathname}
          >
            BUY
          </button>
        </div>
        <div>{music.Price}</div>
        <div>{music.File_GUID}</div>
      </div>
    ));
  }

  return (
    <React.Fragment>
      <Navbar />
      <div className="flex flex-col p-4">
        <Helmet></Helmet>
        <div>{strapiAlbum.Title}</div>
        <div>{strapiAlbum.Price}</div>
        <div className="mt-4">Chansons de l'album:</div>
        {createMusicsInAlbum()}
      </div>
    </React.Fragment>
  );
};

export default AlbumPage;

export const pageQuery = graphql`
  query AlbumsByUrl($path: String!) {
    strapiAlbum(url: { eq: $path }) {
      Title
      Price
      music_tracks {
        id
        Image {
          publicURL
        }
        Price
        Title
        File_GUID
      }
    }
  }
`;
